import { Column, Flex, Row } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

import { Wrapper } from "@faire/retailer/views/brand/logged-out/components/common";
import { ProductsGridSkeletonLoggedOut } from "@faire/retailer/views/brand/ProductsGridSkeleton/ProductsGridSkeletonLoggedOut";

export const LoggedOutBrandPageSkeleton: React.FC = () => {
  return (
    <Wrapper>
      <ResponsiveContentV2
        tabletAndAbove={
          <>
            <LoadingSkeleton width="100%" height="200px" />
            <AvatarLoadingSkeleton />
            <Spacer height="2x" />
          </>
        }
        mobile={<LoadingSkeleton width="100%" height="120px" />}
      />
      <ContentWrapper>
        <ResponsiveContentV2
          mobile={
            <>
              <AvatarLoadingSkeleton />
              <Spacer height="2x" />
            </>
          }
        />
        <StyledColumn>
          <LoadingSkeleton width="100%" height="100px" />
          <Spacer height="1x" />
          <LoadingSkeleton width="100%" height="80px" />
          <Spacer height="3x" />
          <LoadingSkeleton width="228px" height="48px" />
          <Spacer height="3x" />
        </StyledColumn>
        <ProductTileWrapper>
          <ProductsGridSkeletonLoggedOut />
        </ProductTileWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

const AvatarLoadingSkeleton = styled(LoadingSkeleton).attrs({
  width: "96px",
  height: "96px",
  borderRadius: "50%",
})`
  margin-top: -48px;
  ${responsiveMediaQueries.tabletAndAbove} {
    margin-left: 48px;
  }
`;

const StyledColumn = styled(Column).attrs({
  align: { mobileAndAbove: "center", tabletAndAbove: "flex-start" },
})`
  width: 100%;
  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: 350px;
  }
`;

const ProductTileWrapper = styled(Row)`
  width: 100%;
  ${responsiveMediaQueries.tabletAndAbove} {
    padding-left: ${getSpacing("5x")};
  }
`;

const ContentWrapper = styled(Flex).attrs({
  direction: { mobileAndAbove: "column", tabletAndAbove: "row" },
  align: { mobileAndAbove: "center", tabletAndAbove: "normal" },
})`
  padding: ${getSpacing(0, "7x")};
`;
